export default "__VITE_ASSET__DJOAEP7S__"